interface TabMenusProperties {
  menus: { icon?: JSX.Element; activeIcon?: JSX.Element; name: String; count?: number }[];
  openTab: number;
  setOpenTab: (value: number) => void;
}

/**
 * Tab menu function component
 */
function TabMenus({ menus, openTab, setOpenTab }: TabMenusProperties) {
  return (
    <div className="tab-menus-warp">
      <ul style={{ '--menu-count': menus.length } as React.CSSProperties}>
        {menus.map((item, index) => (
          <li
            id={`button-${index}`}
            className={openTab === index ? 'tab active' : 'tab'}
            onClick={() => setOpenTab(index)}
            role="presentation">
            <div>
              {openTab === index ? item.activeIcon : item.icon} {item.name}{' '}
              {item?.count && item?.count > 0 ? (
                <div
                  className="tag tag-danger"
                  style={{
                    top: `${
                      String(item.count).length <= 4 ? -((String(item.count).length - 1) * 2) : -8
                    }px`,
                  }}>
                  {item.count}
                </div>
              ) : (
                ''
              )}
            </div>
          </li>
        ))}
        <li className="bg" />
      </ul>
    </div>
  );
}

export default TabMenus;
